import {
  Button,
  CircularProgress,
  debounce,
  Paper,
  Table,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  useTheme,
} from "@mui/material";
import CustomTableBody from "../../../utilis/component/CustomTableBody";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useMutation } from "react-query";
import { getPatientsList, getPatientsListExcel } from "../../Wallet/service";
import { clinicId } from "../../../constants";
import EditIcon from "@mui/icons-material/Edit";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import DownloadIcon from "@mui/icons-material/Download";
import { Tooltip } from "@mui/material";
import PatientDocumentsModal from "./components/PatientDocumentsModal";
import { useNavigate } from "react-router-dom";
import moduleRoutes from "../../../routes/moduleRouteList";
import dashboardRouteList from "../../routeList";
import patientCareRouteList from "../../../PatientCare/routeList";
import { setItem } from "../../../utilis/methods/storage/storage";
import { calculateAge } from "../../../utilis/methods/dateMethods";
import moment from "moment";
import useRepotFile from "../../../Reports/hooks/reportFileHook";
const baseRoute = (window as any)._env_?.BASE_URL;

const Patients = () => {
  const theme = useTheme();
  const navigateTo = useNavigate();

  const [searchfilter, setSearchfilter] = useState({
    clinicId: clinicId,
    filter: {
      search: "",
    },
    pageSize: 25,
    pageNumber: 0,
  });
  const [docModal, setDocModal] = useState({
    open: false,
    patientId: "",
    patientName: "",
  });
  const handleChangePage = (_: any, newPage: number) => {
    setSearchfilter((prev: any) => ({
      ...prev,
      pageNumber: newPage,
    }));
  };

  const handleChangeRowsPerPage = (event: any) => {
    setSearchfilter((prev: any) => ({
      ...prev,
      pageSize: parseInt(event.target.value, 10),
      pageNumber: 0,
    }));
  };
  const { mutate: getList, data: patientList } = useMutation(getPatientsList);
  const { mutate: downloadExcel, isLoading: excelLoading } = useRepotFile({
    apiFunction: getPatientsListExcel,
    fileType: "xlsx",
  });
  useEffect(() => {
    getList(searchfilter);
  }, [searchfilter]);

  const editReg = (id: number) => {
    navigateTo(
      `${baseRoute}${moduleRoutes.mainRoute}/${moduleRoutes.patientCare}/${patientCareRouteList.patientRegistration}/${id}`,
      {
        state: { Registration: true },
      }
    );
    setItem("selectedTab", "3");
  };

  const handleWalletClick = (patientMasterId: number) => {
    navigateTo(
      `${baseRoute}${moduleRoutes.mainRoute}/${moduleRoutes.dashboard}/${dashboardRouteList.patientWallet}/${patientMasterId}`,
      {
        state: { wallet: true },
      }
    );
    setItem("selectedTab", "3");
  };

  const onTextChange = useCallback((event: any) => {
    setSearchfilter((prev: any) => ({
      ...prev,
      filter: {
        ...prev.filter,
        search: event.target.value,
      },
    }));
  }, []);
  const debounceSearch = useMemo(
    () => debounce(onTextChange, 300),
    [onTextChange]
  );

  const handleDownloadExcel = () => {
    downloadExcel(searchfilter);
  };
  const diplayAge = (dob: string) => {
    const age = calculateAge(dob || "");
    return `${age.age || ""} ${age.ageType}`;
  };
  return (
    <Paper>
      <div className="flex flex-col gap-3 p-5 border-b sm:flex-row sm:items-center">
        <TextField
          onChange={(e: any) => {
            debounceSearch(e);
          }}
          size="small"
          className="w-full sm:flex-1"
          fullWidth
          label="Search by Mob / Name"
          id="patient-search"
        />
        <Button
          variant="contained"
          color="success"
          onClick={handleDownloadExcel}
          disabled={excelLoading}
          endIcon={
            excelLoading ? (
              <CircularProgress size={18} color="inherit" />
            ) : (
              <DownloadIcon />
            )
          }
          sx={{
            whiteSpace: "nowrap",
            height: 40,
            minWidth: { xs: "100%", sm: 160 },
            flexShrink: 0,
          }}
        >
          Download Excel
        </Button>
      </div>
      <Table size="small" sx={{ opacity: 1, zIndex: 10, padding: "20px" }}>
        <TableHead className="sticky top-0 border-2">
          <TableRow sx={{ backgroundColor: theme.palette.primary.main }}>
            {headings?.map((title, index) => (
              <TableCell
                key={index}
                sx={{
                  fontWeight: "bold",
                  color: theme.palette.background.paper,
                }}
              >
                {title}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <CustomTableBody
          alert={"No records found"}
          isData={true}
          totalSpan={{ row: 2, col: 7 }}
          dataLoading={false}
        >
          {patientList?.results?.map((item: any, index: number) => (
            <TableRow>
              <TableCell>
      {searchfilter.pageNumber * searchfilter.pageSize + index + 1}
    </TableCell>
              <TableCell key={index}>{item.emrNo}</TableCell>
              <TableCell key={index}>{item.fullName}</TableCell>
              <TableCell key={index}>{item.civilId}</TableCell>
              <TableCell key={index}>{item.gccId || "-"}</TableCell>
              <TableCell  key={index}>{item?.passportNo||"-"}</TableCell>
          
              <TableCell key={index}>{diplayAge(item?.dateOfBirth)}</TableCell>
              <TableCell key={index}>{moment(item?.dateOfBirth).format("DD-MM-YYYY")}</TableCell>

              <TableCell key={index}>{item.gender}</TableCell>
              <TableCell key={index}>{item.mobile}</TableCell>
              <TableCell key={index}>{moment(item.foDate).format("DD-MM-YYYY")}</TableCell>
              <TableCell key={index}>
                <div className="flex gap-x-4  ">
                  <div
                    onClick={() => {
                      editReg(item.patientMasterId);
                    }}
                  >
                    <EditIcon className="cursor-pointer" color="primary" />
                  </div>
                  <div onClick={() => handleWalletClick(item.patientMasterId)}>
                    <AccountBalanceWalletIcon
                      className="cursor-pointer"
                      color="secondary"
                    />{" "}
                  </div>
                  <div
                    onClick={() =>
                      setDocModal({
                        open: true,
                        patientId: item.emrNo,
                        patientName: item.fullName,
                      })
                    }
                  >
                    <Tooltip title="View Documents">
                      <FileCopyIcon className="cursor-pointer" color="info" />
                    </Tooltip>
                  </div>
                </div>
              </TableCell>
            </TableRow>
          ))}
        </CustomTableBody>
        <TablePagination
          rowsPerPageOptions={[5, 10, 15, 25]}
          count={patientList?.totalCount || 0}
          rowsPerPage={searchfilter.pageSize || 0}
          page={searchfilter.pageNumber || 0}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Table>
      <PatientDocumentsModal
        open={docModal.open}
        patientId={docModal.patientId}
        patientName={docModal.patientName}
        onClose={() => setDocModal((prev) => ({ ...prev, open: false }))}
      />
    </Paper>
  );
};

export default Patients;

const headings = [
    "SL No", 
"EMR NO/REG NO",
  "Patient Name",
  "Civil ID",
  "GCC ID",
  "Passport No",
  "Age",
  "DOB",
  "Gender",
  "Mobile",
  "Reg.Date",
  "Action",
];
